import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { inject, observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import * as mobx from 'mobx'
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import InputAdornment from '@material-ui/core/InputAdornment';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import Search from '@material-ui/icons/Search';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import ListIcon from '@material-ui/icons/List';
import ViewListIcon from '@material-ui/icons/ViewList';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import moment from 'moment';
import commonStore from '../../stores/commonStore';

let counter = 0;

function getSorting(order, orderBy) {
 
  if (order === 'desc'){
    return (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
  }else{
    return (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1)
  }
  return 0
}

let count = 0

function getSorting(order, orderBy, thenBy) {

  if (order === 'desc'){
    return (a, b) => {
      count = count + 1

      if (b[orderBy] < a[orderBy] || b[thenBy] < a[thenBy]) return -1;
      if (b[orderBy] > a[orderBy] || b[thenBy] > a[thenBy]) return 1;
      return 0;
    }
  }else{
    return (a, b) => {
      if (b[orderBy] > a[orderBy] || b[thenBy] > a[thenBy]) return -1;
      if (b[orderBy] < a[orderBy] || b[thenBy] < a[thenBy]) return 1;
      return 0;
    }
  }
}

function jsUcfirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function makeLabel(value){
  const splitArray = value.split('_')
  if(splitArray.length > 1){
    return `${jsUcfirst(splitArray[0])} ${jsUcfirst(splitArray[1])}`
  }
  return jsUcfirst(value)
}


const styles = theme => ({
  root: {
    flexGrow: 1,
   // paddingRight: theme.spacing.unit,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justify: 'flex-end',
    direction: 'row',
    margin: theme.spacing.unit * .5,
  },
  searchContainer: {
    marginBottom: theme.spacing.unit
  },
  totals:{
    marginBottom: theme.spacing.unit
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },

  actions: {
    color: theme.palette.text.secondary,
  },
  button: {
    margin: theme.spacing.unit * .5,
  },
  buttonCloud:{
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    marginLeft:theme.spacing.unit * 2
  },
  title: {

  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
});


const lastResultCodes = [
  {name: 'APPT', color: '#036daf'},
  {name: 'Contacted', color: '#0089ba'},
  {name: 'Follow Up', color: '#06aa8f'},
  {name: 'Incorrect Person', color: '#ad03a4'},
  {name: 'DNC', color: '#757575'},
  {name: 'DNQ', color: '#ad0505'},
  {name: 'Give Up', color: '#b75e00'},
  {name: 'NI/Covered', color: '#a9055a'},
  {name: 'No_Contact', color: '#c63f81'},
  {name: 'Retry___', color: '#cc9502'},
  {name: 'SOLD', color: '#00af1a'},
  {name: 'Spanish', color: '#a3690d'},
  {name: 'Transfer', color: '#6b6b6b'},
  {name: 'Non-Working Number', color: '#ad03a4'},
]


@observer
@inject("commonStore")
class SonicGridToolbar extends React.Component {

//let SonicGridToolbar = props => {

  state = {
    anchorCampaignEl: null,
    anchorLastResultEl: null,
    anchor_leadTypeEl: null,
    anchor_qualifierEl: null,
    anchor_contactTypeEl: null,
    startDate: moment().startOf('day'),
    endDate:   moment(),
  };


  handleClose = (anchor) => {
    this.setState({ [anchor]: null });
  };
  customDateSearch = () => {
    console.log('customDateSearch')
    const { startDate, endDate } = this.state
    const { searchDatesUpdated } = this.props
    console.log(startDate)
    console.log(startDate)
    searchDatesUpdated({startDate, endDate})

  }
  customDateUpdated = (type, date) => {
    console.log('customDateUpdated')
    const temp = {}
    temp[type] = date
    console.log(temp)
    this.setState(temp)
  }
  setPredefinedDate = (dateName) => {

    const {  searchDatesUpdated } = this.props

    let endDate
    let startDate
    switch (dateName) {
      case 'today':
      endDate = moment()
      startDate = moment().startOf('day')
      break
      case 'yesterday':
      endDate = moment().startOf('day')
      startDate = moment().add(-1, 'days').startOf('day')
      break
      case 'weekToDate':
      endDate = moment()
      startDate = moment().startOf('week').isoWeekday(1);
      break
      case 'monthToDate':
      endDate = moment()
      startDate = moment().startOf('month')
      break
      defualt:
      endDate = moment()
      startDate = moment().startOf('day')
    }

      searchDatesUpdated({startDate, endDate})


    //searchDateUpdated('startDate', startDate)
   // searchDateUpdated('endDate', endDate)
    //searchDate()

  }
  handleCampaignSelection = (campaignID, name) => {

    const { campaignSelected } = this.props
    campaignSelected(campaignID)
    this.setState({ anchorCampaignEl: null, selectedCampaignName:  name});
  }
  handleLastResultSelection = (lastResult, name ) => {
    const { lastResultSelected } = this.props
    lastResultSelected(lastResult)
    this.setState({ anchorLastResultEl: null, selectedLastResultName:  name});
  }

  handleFilterSelection = (item) => {
    const key = Object.keys(item)
    const { filterSelected } = this.props
    filterSelected(item[key])
    this.setState({ [`anchor_${key}El`]: null, [`selected_${[key]}`]:  item[key]});
  }
  
  makeCampaignMenu = () => {

    const { commonStore, campaignSelected } = this.props
    const { campaigns } = commonStore

    const arrayOfCampaigns = campaigns.map(campaign => {
      console.log(campaign.campaignName)
      return <MenuItem key={campaign.campaignID} onClick={ () => {this.handleCampaignSelection(campaign.campaignID, campaign.campaignName)}}>{campaign.campaignName}</MenuItem>
    })

    arrayOfCampaigns.unshift(<MenuItem key={'noCampaign'} onClick={ () => {this.handleCampaignSelection(null)}}>{'All Campaigns'}</MenuItem>)

    return arrayOfCampaigns
  }
  makeLastResultMenu = () => {
    const lastArray = lastResultCodes.map(lastResult => {
      return <MenuItem key={lastResult.name} onClick={ () => {this.handleLastResultSelection(lastResult.name, lastResult.name)}}>{lastResult.name}</MenuItem>
    })

    lastArray.unshift(<MenuItem key={'noResult'} onClick={ () => {this.handleLastResultSelection(null)}}>{'All Results'}</MenuItem>)

    return lastArray
  }

  makeLeadTypeMenu = () => {
    const { commonStore } = this.props
    const { network } = commonStore
    const { types } = network
    const { leadTypes } = types
    
    const leadTypesArray = leadTypes.map(leadType => {
      return <MenuItem key={leadType} onClick={ () => {this.handleFilterSelection({leadType})}}>{makeLabel(leadType)}</MenuItem>
    })

    leadTypesArray.unshift(<MenuItem key={'noResult'} onClick={ () => {this.handleFilterSelection(null)}}>{'All Results'}</MenuItem>)

    return leadTypesArray
  }
  makeQualifierMenu = () => {
    const { commonStore } = this.props
    const { network } = commonStore
    const { types } = network
    const { qualifiers } = types

    const qualifiersArray = qualifiers.map(qualifier => {
      return <MenuItem key={qualifier} onClick={ () => {this.handleFilterSelection({qualifier})}}>{makeLabel(qualifier)}</MenuItem>
    })

    qualifiersArray.unshift(<MenuItem key={'noResult'} onClick={ () => {this.handleFilterSelection(null)}}>{'All Results'}</MenuItem>)

    return qualifiersArray
  }
  makeContactTypeMenu = () => {
    const { commonStore } = this.props
    const { network } = commonStore
    const { types } = network
    const { contactTypes } = types

    const contactTypesArray = contactTypes.map(contactType => {
      return <MenuItem key={contactType} onClick={ () => {this.handleFilterSelection({contactType})}}>{makeLabel(contactType)}</MenuItem>
    })

    contactTypesArray.unshift(<MenuItem key={'noResult'} onClick={ () => {this.handleFilterSelection(null)}}>{'All Results'}</MenuItem>)

    return contactTypesArray
  }
  render() {
    const { startDate, endDate, anchorCampaignEl, anchorLastResultEl, anchor_leadTypeEl, anchor_qualifierEl, anchor_contactTypeEl, selectedCampaignName, selectedLastResultName, selected_leadType, selected_qualifier, selected_contactType } = this.state;
    const { commonStore, numSelected, classes, title, search, checkbox, showDateSearch, toggleDateSearch, defaultDateRange, searchDatesUpdated, selectedCampaign, searchDate, changeView, changeColumns, currentItems, totalItems, exportCSV } = this.props;
    const { loading } = commonStore


  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0 && checkbox,
      })}
    >

    <div className={classes.root}>
    <Grid container alignItems={'center'} justify="space-between">
        
        <Grid item xs={3}>
        <Grid item container direction="row" justify="flex-start">   
        <IconButton className={classes.button} aria-label="list" onClick={() => {changeView('list')}}>
            <ListIcon />
        </IconButton>
        <IconButton className={classes.button} aria-label="cells" onClick={() => {changeView('cells')}}>
            <ViewListIcon />
        </IconButton>
        <IconButton className={classes.button} aria-label="cells" onClick={() => {changeColumns()}}>
            <ViewColumnIcon />
        </IconButton>
        <IconButton className={classes.buttonCloud} aria-label="cells" onClick={() => {exportCSV()}}>
        <CloudDownloadIcon />
      </IconButton>
        </Grid>
    </Grid>
        <Grid item xs={6} className={classes.container}>
        <Button color="primary" className={classes.button} onClick={() => {this.setPredefinedDate('today')}}>Today</Button>
        <Button color="primary" className={classes.button} onClick={() => {this.setPredefinedDate('yesterday')}}>Yesterday</Button>
        <Button color="primary" className={classes.button} onClick={() => {this.setPredefinedDate('weekToDate')}}>Week</Button>
        <Button color="primary" className={classes.button} onClick={() => {this.setPredefinedDate('monthToDate')}}>Month</Button>
        <Button color={showDateSearch ? 'secondary' : 'primary'} className={classes.button} onClick={() => {toggleDateSearch()}}>{showDateSearch ? 'Close' : 'Custom'} </Button>
        {showDateSearch ? 
        <form className={classes.container} noValidate>
        <TextField
          id="datetime-local"
          label="Start"
          type="datetime-local"
          defaultValue={startDate.format('YYYY-MM-DDTHH:MM')}
          className={classes.textField}
          onChange={(event) => {this.customDateUpdated('startDate', moment(event.target.value))}}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
        id="datetime-local"
        label="End"
        type="datetime-local"
        defaultValue={endDate.format('YYYY-MM-DDTHH:MM')}
        className={classes.textField}
        onChange={(event) => {this.customDateUpdated('endDate', moment(event.target.value))}}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <Button color="primary" className={classes.button} onClick={() => {this.customDateSearch()}}>Search</Button>
      </form> : null}
        </Grid>
        <Grid item xs={2}>
        <Grid item container direction="column" justify="flex-start">   
            <TextField
            fullWidth
            id="search"
            label="Search"
            type="search"
            onChange={search}
            className={classes.textField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            margin="normal"
          />
                <Grid item container direction="row" justify="flex-start" className={classes.searchContainer}>   
            
                <div>
                <Button
                  aria-owns={anchorCampaignEl ? 'simple-menu1' : null}
                  aria-haspopup="true"
                  onClick={(event) => this.setState({anchorCampaignEl: event.currentTarget})}
                >
                  {selectedCampaignName ?  selectedCampaignName : 'All Campaigns'}
                </Button>
                <Menu
                  id="simple-menu1"
                  anchorEl={anchorCampaignEl}
                  open={Boolean(anchorCampaignEl)}
                  onClose={() => this.handleClose('anchorCampaignEl')}
                >
                  {this.makeCampaignMenu()}
                </Menu>
              </div>

              <div>
              <Button
                aria-owns={anchorLastResultEl ? 'simple-menu2' : null}
                aria-haspopup="true"
                onClick={(event) => this.setState({anchorLastResultEl: event.currentTarget})}
              >
                {selectedLastResultName ?  selectedLastResultName : 'All Results'}
              </Button>
              <Menu
                id="simple-menu2"
                anchorEl={anchorLastResultEl}
                open={Boolean(anchorLastResultEl)}
                onClose={() => this.handleClose('anchorLastResultEl')}
              >
                {this.makeLastResultMenu()}
              </Menu>
            </div>
            <div>
            <Button
              aria-owns={anchor_leadTypeEl ? 'simple-menu3' : null}
              aria-haspopup="true"
              onClick={(event) => this.setState({anchor_leadTypeEl: event.currentTarget})}
            >
              {selected_leadType ?  selected_leadType : 'Lead Types'}
            </Button>
            <Menu
              id="simple-menu3"
              anchorEl={anchor_leadTypeEl}
              open={Boolean(anchor_leadTypeEl)}
              onClose={() => this.handleClose('anchor_leadTypeEl')}
            >
              {this.makeLeadTypeMenu()}
            </Menu>
          </div>
          <div>
          <Button
            aria-owns={anchor_qualifierEl ? 'simple-menu4' : null}
            aria-haspopup="true"
           onClick={(event) => this.setState({anchor_qualifierEl: event.currentTarget})}
          >
            {selected_qualifier ?  selected_qualifier : 'Qualifiers'}
          </Button>
          <Menu
            id="simple-menu4"
            anchorEl={anchor_qualifierEl}
            open={Boolean(anchor_qualifierEl)}
            onClose={() => this.handleClose('anchor_qualifierEl')}
          >
            {this.makeQualifierMenu()}
          </Menu>
        </div>
        <div>
        <Button
          aria-owns={anchor_contactTypeEl ? 'simple-menu5' : null}
          aria-haspopup="true"
         onClick={(event) => this.setState({anchor_contactTypeEl: event.currentTarget})}
        >
          {selected_contactType ?  selected_contactType : 'Contact Types'}
        </Button>
        <Menu
          id="simple-menu5"
          anchorEl={anchor_contactTypeEl}
          open={Boolean(anchor_contactTypeEl)}
          onClose={() => this.handleClose('anchor_contactTypeEl')}
        >
          {this.makeContactTypeMenu()}
        </Menu>
      </div>
            </Grid>
        </Grid>
        </Grid>
        </Grid>
        {loading ? 'Loading...' : <Typography className={classes.totals}> {`Showing ${currentItems} of ${totalItems}`}</Typography>}
      </div>
    </Toolbar>
  );
  }
};

SonicGridToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired
};



export default withStyles(styles)(SonicGridToolbar);


// WEBPACK FOOTER //
// ./src/components/lib/SonicGridToolBar.js